<template>
    <div class="receivable_list_wrap" v-loading="loading">
        <el-tabs v-model="tabActiveName" @tab-click="handleClickTab">
            <el-tab-pane label="待确认" name="1"> </el-tab-pane>
            <el-tab-pane label="已确认" name="2"> </el-tab-pane>
            <el-tab-pane label="已驳回" name="3" v-if="source_type !== 'purchase_refund'"> </el-tab-pane>
        </el-tabs>
        <div class="content_right_wrap">
            <div class="page-filter_wrap">
                <div class="page-filter_wrap_left">
                    <el-input
                        v-model="searchForm.keyword"
                        class="filter-input"
                        clearable
                        placeholder="请输入您想搜索的内容"
                        @clear="handleClickSearch"
                        @keyup.enter.native="handleClickSearch"
                    >
                        <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                    </el-input>
                    <el-popover placement="bottom-start" width="520" trigger="click">
                        <div class="search_container">
                            <div class="search_top_container">
                                <span class="title">筛选</span>
                                <el-button
                                    @click="handleClickReset"
                                    size="mini"
                                    :disabled="
                                        searchFilterList.findIndex((find) => find.field_value) > -1 ? false : true
                                    "
                                    >清空筛选条件</el-button
                                >
                            </div>
                            <div class="search_bottom_container">
                                <ul>
                                    <li v-for="item in searchFilterList">
                                        <div>
                                            <el-select size="small" v-model="item.field_key" disabled>
                                                <el-option label="申请人" value="uid"></el-option>
                                                <el-option label="创建时间" value="apply_time_range"></el-option>
                                                <el-option label="确认时间" value="confirm_time_range"></el-option>
                                                <el-option label="收款方式" value="payment_method"></el-option>
                                                <el-option label="驳回时间" value="reject_time_range"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="search_filter_type">
                                            <el-select size="small" v-model="item.field_type" disabled>
                                                <el-option label="满足" value="eq"></el-option>
                                                <el-option label="不满足" value="neq"></el-option>
                                            </el-select>
                                        </div>
                                        <div>
                                            <template v-if="item.field_key == 'uid'">
                                                <el-select
                                                    v-model="item.field_value"
                                                    placeholder="请选择申请人"
                                                    :remote-method="getUserList"
                                                    filterable
                                                    remote
                                                    size="small"
                                                    @change="handleClickSearch"
                                                    clearable
                                                >
                                                    <el-option
                                                        v-for="user in userOptions"
                                                        :key="user.uid"
                                                        :label="user.name"
                                                        :value="user.uid"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </template>
                                            <template
                                                v-if="
                                                    item.field_key == 'apply_time_range' ||
                                                    item.field_key == 'confirm_time_range' ||
                                                    item.field_key == 'reject_time_range'
                                                "
                                            >
                                                <el-date-picker
                                                    v-model="item.field_value"
                                                    :editable="false"
                                                    end-placeholder="结束时间"
                                                    format="yyyy-MM-dd"
                                                    range-separator="～"
                                                    size="small"
                                                    start-placeholder="开始时间"
                                                    type="daterange"
                                                    value-format="yyyy-MM-dd"
                                                    @clear="item.field_value = []"
                                                    @change="handleClickSearch"
                                                >
                                                </el-date-picker>
                                            </template>
                                            <template v-if="item.field_key == 'payment_method'">
                                                <el-select
                                                    placeholder="请选择收款方式"
                                                    v-model="item.field_value"
                                                    size="small"
                                                    clearable
                                                    @change="handleClickSearch"
                                                >
                                                    <el-option
                                                        :label="item.name"
                                                        :value="item.value"
                                                        v-for="item in payTypeList"
                                                    ></el-option>
                                                </el-select>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <el-button size="small" slot="reference" class="custom_popover_button">
                            <i class="iconfont icon-shaixuan"></i>
                            <span
                                class="search_filter_length"
                                v-if="searchFilterList.filter((find) => find.field_value).length"
                            >
                                <span
                                    v-text="searchFilterList.filter((find) => find.field_value).length + '个条件'"
                                ></span>
                                <i class="el-icon-error" @click="handleClickReset"></i>
                            </span>
                        </el-button>
                    </el-popover>
                </div>
                <div class="page-filter_wrap_right">
                    <el-button type="primary" plain v-if="hasOperatePermission" @click="handleClickExport">导出</el-button>
                    <el-button
                        type="primary"
                        plain
                        @click="handleClickBatchReject"
                        v-if="(source_type !== 'purchase_refund' && tabActiveName == 1) && hasOperatePermission"
                        >批量驳回</el-button
                    >
                    <el-button type="primary" @click="handleClickBatchConfirm" v-if="tabActiveName == 1 && hasOperatePermission"
                        >批量确认</el-button
                    >
                </div>
            </div>
            <div class="page-content">
                <CustomVxeTable
                    :id="getRandomId(1, 100)"
                    :ref="'tableRef' + source_type"
                    :customConfig="tableCustomConfig"
                    :empty-render="{ name: 'NotData' }"
                    :isShowToolBar="true"
                    :pagination.sync="pagination"
                    :reduceHeight="reduceHeight"
                    :tableData="tableData"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    @selection-change="selectionChange"
                >
                    <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                    <template v-if="source_type == 'order'">
                        <vxe-column field="receivable_no" title="回款编号" minWidth="200" key="1">
                            <template #default="{ row }">
                                <span class="link-label" @click="handleClickPaymentDetail(row)">
                                    {{ row.receivable_no }}</span
                                >
                                <el-tooltip
                                    v-if="row.invalid_time"
                                    popper-class="status_tooltip_item"
                                    effect="dark"
                                    :content="row.invalid_reason"
                                    placement="bottom"
                                >
                                    <span class="handle_icon_wrap">
                                        <i class="iconfont icon-quxiaokaohe"></i>
                                    </span>
                                </el-tooltip>
                            </template>
                        </vxe-column>
                        <vxe-column field="customer_info_name" title="客户公司" min-width="164" show-overflow key="2">
                            <template #default="{ row }">
                                <span
                                    class="link-label"
                                    @click="
                                        handleClickCustomerDetail(
                                            row.customer_info && row.customer_info.id,
                                            row.customer_info && row.customer_info.name
                                        )
                                    "
                                    >{{ row.customer_info && row.customer_info.name }}</span
                                >
                            </template>
                        </vxe-column>
                        <vxe-column field="payment_company_name" title="回款公司" min-width="164" show-overflow key="3">
                            <template #default="{ row }">
                                <span>{{ row.payment_company_name }}</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="order_no" title="订单编号" min-width="160" show-overflow key="4">
                            <template #default="{ row }">
                                <span class="link-label" @click="handleClickOrderDetail(row)">{{ row.order_no }}</span>
                            </template>
                        </vxe-column>
                    </template>
                    <template v-if="source_type == 'purchase_refund'">
                        <vxe-column field="receivable_no" title="应收编号" fixed="left" min-width="200" key="5">
                            <template #default="{ row }">
                                <div>
                                    <span class="link-label" @click="handleClickReceivableDetail(row)">{{
                                        row.receivable_no
                                    }}</span>
                                    <el-tooltip
                                        v-if="row.invalid_time"
                                        popper-class="status_tooltip_item"
                                        effect="dark"
                                        :content="row.invalid_reason"
                                        placement="bottom"
                                    >
                                        <span class="handle_icon_wrap">
                                            <i class="iconfont icon-quxiaokaohe"></i>
                                        </span>
                                    </el-tooltip>
                                </div>
                            </template>
                        </vxe-column>
                        <vxe-column field="supplier_name" title="供应商名称" min-width="200" show-overflow key="6">
                            <template #default="{ row }">
                                <span>{{ row.supplier_name }}</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="purchase_no" title="采购编号" min-width="160" show-overflow key="7">
                            <template #default="{ row }">
                                <span class="link-label" @click="handleClickRelateId(row.purchase_id)">{{
                                    row.purchase_refund_no
                                }}</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="approval_id" title="审批编号" min-width="160" show-overflow key="8">
                            <template #default="{ row }">
                                <span class="link-label" @click="handleClickApprovalDetail(row.approval_id)">{{
                                    row.approval_id
                                }}</span>
                            </template>
                        </vxe-column>
                    </template>
                    <vxe-column field="user_name" title="申请人" width="150">
                        <template #default="{ row }">
                            <PersonnelCard :userId="row.uid_info.id" v-if="row.uid_info && row.uid_info.id">
                                <template slot="container">
                                    <div class="user-avatar-btn">
                                        <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                        <span>{{ row.uid_info.name }}</span>
                                    </div>
                                </template>
                            </PersonnelCard>
                        </template>
                    </vxe-column>
                    <template v-if="tabActiveName == 1">
                        <vxe-column field="created_at" title="创建时间" min-width="178" show-overflow key="9">
                            <template #default="{ row }">
                                <span>{{ row.created_at }}</span>
                            </template>
                        </vxe-column>
                    </template>
                    <template v-else-if="tabActiveName == 2">
                        <vxe-column field="created_at" title="确认时间" min-width="178" show-overflow key="10">
                            <template #default="{ row }">
                                <span>{{ row.confirmations && row.confirmations.confirm_time }}</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="payment_method" title="收款方式" min-width="80" show-overflow key="11">
                            <template #default="{ row }">
                                <span>{{ row.confirmations && row.confirmations.payment_method_name }}</span>
                            </template>
                        </vxe-column>
                    </template>

                    <vxe-column
                        header-align="right"
                        align="right"
                        field="receivable_amount"
                        title="应收款金额"
                        min-width="126"
                        show-overflow
                    >
                        <template #default="{ row }">
                            <span
                                v-text="
                                    Number(row.receivable_amount).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })
                                "
                            ></span>
                        </template>
                    </vxe-column>
                    <template v-if="tabActiveName == 2">
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="confirmed_amount"
                            title="已确认金额"
                            min-width="126"
                            show-overflow
                            key="12"
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.confirmed_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </vxe-column>
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="remark"
                            title="备注"
                            min-width="235"
                            show-overflow
                            key="13"
                        >
                            <template #default="{ row }">
                                <template v-if="source_type == 'order'">
                                    <el-input
                                        v-if="row.isEditRemark && row.confirmations && hasOperatePermission"
                                        class="custom-table_row_input"
                                        v-model="row.confirmations.remark"
                                        @blur="handleBlur(row)"
                                    ></el-input>
                                    <span v-else @click="handleClickRowEdit(row, 'isEditRemark')">{{ row.confirmations && row.confirmations.remark }}</span>
                                </template>
                                <span v-else>{{ row.confirmations && row.confirmations.remark }}</span>
                            </template>
                        </vxe-column>
                    </template>
                    <template v-if="tabActiveName == 3">
                        <vxe-column field="reject_time" title="驳回时间" min-width="178" show-overflow key="14">
                            <template #default="{ row }">
                                <span>{{ row.rejections && row.rejections.reject_time }}</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="reject_reason" title="驳回原因" min-width="235" show-overflow key="15">
                            <template #default="{ row }">
                                <span>{{ row.rejections && row.rejections.reject_reason }}</span>
                            </template>
                        </vxe-column>
                    </template>
                    <vxe-column field="operate" width="90" fixed="right">
                        <template #header>
                            <span>操作</span>
                            <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                            </el-tooltip>
                        </template>
                        <template #default="{ row }">
                            <el-dropdown placement="bottom-end" trigger="click" v-if="hasOperatePermission">
                                <el-tooltip effect="dark" content="更多" placement="top"
                                    ><i class="iconfont el-icon-more cursor"></i
                                ></el-tooltip>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        @click.native="handleClickReceivedConfirm(row)"
                                        v-if="row.status == 1"
                                    >
                                        确认
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        @click.native="handleClickInvalidConfirm(row)"
                                        v-if="row.status == 2 && !row.invalid_time"
                                    >
                                        作废
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        @click.native="handleClickReject(row)"
                                        v-if="source_type == 'order' && row.status == 1"
                                        >驳回</el-dropdown-item
                                    >

                                    <el-dropdown-item @click.native="handleClickReceivableDetail(row)">
                                        详情
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </vxe-column>
                    <template #empty>
                        <div class="custom-table-empty">
                            <div class="custom-table-empty-img"></div>
                            <p class="custom-table-empty-txt">暂无数据</p>
                        </div>
                    </template>
                </CustomVxeTable>
            </div>
        </div>

        <PaymentConfirmation
            v-if="paymentConfirmationDialog"
            :paymentConfirmationDialog.sync="paymentConfirmationDialog"
            :receivable_no="receivable_no"
            :confirmType="confirmType"
            :source_type="source_type"
            @confirmSuccess="handleClickSearch"
            @handleClickLookPaymentDetail="handleClickPaymentDetail"
        />
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="handleDialogTitle"
            :visible.sync="handleDialogVisible"
            width="520px"
            @close="handleClickCancel"
        >
            <p class="dialog_label_text">{{ handleDialogTitle }}</p>
            <el-input
                :placeholder="'请输入' + handleDialogTitle"
                :rows="6"
                maxlength="200"
                type="textarea"
                v-model="handleRemarks"
            >
            </el-input>
            <div align="right" slot="footer">
                <el-button @click="handleClickCancel" size="small">取消</el-button>
                <el-button @click="handleClickConfirm" size="small" type="primary">确定</el-button>
            </div>
        </el-dialog>
        <RepaymentDetails
            v-if="repaymentDetailDialogVisible"
            :dialogVisible.sync="repaymentDetailDialogVisible"
            :receivable_no="receivable_no"
        />
        <ReceivableDetails
            v-if="receivableDetailsVisible"
            :receivableDetailsVisible.sync="receivableDetailsVisible"
            :receivable_no="receivable_no"
        />
        <PurchaseDetail
            :purchaseDetailVisible.sync="purchaseDetailVisible"
            v-if="purchaseDetailVisible"
            :purchaseId="purchaseId"
        />
    </div>
</template>
<script>
import { ReceivableList, GetUserList, ReceivableBatchReject, ReceivableInvalid ,ReceivableNoteUpdate, ReceivableListExport} from "@/api";
import { pagination } from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";
import PaymentConfirmation from "./component/payment_confirmation.vue";
import ReceivableDetails from "./component/receivable_details.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import PurchaseDetail from "../../Purchase/component/purchase_detail.vue"; //采购详情
import RepaymentDetails from "./component/repayment_details.vue";
import * as XLSX from "xlsx";
import {mapGetters} from "vuex";

export default {
    name: "ReceivableList",
    components: {
        CustomVxeTable,
        ListAdvancedFiltering,
        PaymentConfirmation,
        ReceivableDetails,
        PersonnelCard,
        PurchaseDetail,
        RepaymentDetails,
    },
    props: {
        source_type: {
            type: String,
            default: "",
        }, // 回款类型：采购=purchase_refund，订单：order
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading: false,
            tabActiveName: "1",
            searchForm: {
                keyword: "",
            },
            fieldsList: [],
            systemFilterFields: [],
            custom_filter: {},
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "checkbox";
                },
                checkMethod: (col) => {
                    return col.column.field !== "receivable_no";
                },
                allowSort: true,
            },
            tableData: [],
            selectedList: [],
            // 收款确认
            paymentConfirmationDialog: false,
            receivable_no: "", // 应收单号
            confirmType: "payment",
            // 取消付款和付款失败
            handleDialogType: "",
            handleDialogTitle: "",
            handleDialogVisible: false,
            handleRemarks: "",
            handleDialogIds: [],
            // 详情
            receivableDetailsVisible: false,
            // 筛选条件
            searchFilterList: [],
            allSearchFilterList: {
                1: [
                    {
                        field_key: "uid",
                        field_name: "申请人",
                        field_value: "",
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "apply_time_range",
                        field_name: "创建时间",
                        field_value: "",
                        field_value_name: "",
                        field_type: "eq",
                    },
                ],
                2: [
                    {
                        field_key: "uid",
                        field_name: "申请人",
                        field_value: "",
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "confirm_time_range",
                        field_name: "确认时间",
                        field_value: "",
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "payment_method",
                        field_name: "收款方式",
                        field_value: "",
                        field_value_name: "",
                        field_type: "eq",
                    },
                ],
                3: [
                    {
                        field_key: "uid",
                        field_name: "申请人",
                        field_value: "",
                        field_value_name: "",
                        field_type: "eq",
                    },
                    {
                        field_key: "reject_time_range",
                        field_name: "驳回时间",
                        field_value: "",
                        field_value_name: "",
                        field_type: "eq",
                    },
                ],
            },
            userOptions: [],
            payTypeList: [
                { name: "电汇", value: 1 },
                { name: "微信", value: 2 },
                { name: "支付宝", value: 3 },
                { name: "现金", value: 4 },
                { name: "银行承兑", value: 5 },
                { name: "商业承兑", value: 6 },
                { name: "支票", value: 7 },
            ],

            purchaseId: null,
            purchaseDetailVisible: false, //采购详情
            repaymentDetailDialogVisible: false,
        };
    },
    computed: {
        reduceHeight() {
            return this.pagination.total > 0 ? 215 : 170;
        },
        ...mapGetters(['hasPermission']),
        // 操作权限：付款、确认、取消、驳回、作废等操作；因为后台权限设置的是同一个按钮，所以判断一个权限的类型就行，如果之后权限分开了之后，就需要判断某一个按钮的权限了；目前我这里根据批量驳回的权限判断的
        hasOperatePermission() {
            return this.hasPermission('finance.receivable.batchReject', 'finance', 'ReceivableManage');
        },
    },
    mixins: [pagination],
    watch: {
        source_type(newVal, oldVal) {
            if (newVal) {
                this.tabActiveName = (this.$route.query && this.$route.query.tab) ? String(this.$route.query.tab): "1";
                this.tableData = [];
                this.handleClickTab();
            }
        },
    },
    mounted() {
        if (this.source_type) {
            this.tabActiveName = (this.$route.query && this.$route.query.tab) ? String(this.$route.query.tab): "1";;
            this.handleClickTab();
        }
        this.getUserList();
    },
    methods: {
        handleClickTab() {
            this.searchForm.keyword = "";
            this.searchFilterList = this.allSearchFilterList[this.tabActiveName];
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", "");
            });
            this.selectedList = [];
            this.handleCurrentChange(1);
        },
        getRandomId(min, max) {
            min = Math.ceil(min); // 将min向上取整
            max = Math.floor(max); // 将max向下取整
            return String(Math.floor(Math.random() * (max - min + 1)) + min); // 返回min到max之间的随机整数
        },
        handleClickRowEdit(row, status) {
            this.$set(row, status, true)
        },
        // 防抖
        debounce(func, wait) {
            let timeout;
            return function (...args) {
                const later = () => {
                    timeout = null;
                    func.apply(this, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },
        // 编辑备注
        handleRemarkUpdate(row) {
            const params = {
                receivable_no: row.receivable_no,
                remark: row.confirmations.remark
            }
            if(!params.receivable_no) return;
            ReceivableNoteUpdate(params).then(res=> {
                if(res.code === 200) {
                    this.$message.success("更改成功")
                    this.$set(row, 'isEditRemark', false)
                }
            })
        },
        handleBlur(row) {
            this.debounce(this.handleRemarkUpdate, 300)(row);
        },
        // 搜索
        handleClickSearch() {
            this.handleCurrentChange(1);
        },
        // 清空筛选条件
        handleClickReset() {
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", "");
            });
            this.handleClickSearch();
        },
        // 表头配置
        handleClickCustom() {
            this.$refs["tableRef" + this.source_type].handleOpenCustomShow();
        },
        // 表格复选框
        selectionChange(ids) {
            this.selectedList = ids;
        },
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code === 200) {
                    this.userOptions = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            let postData = {
                source_type: this.source_type,
                status: this.tabActiveName,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    postData[item.field_key] = item.field_value;
                }
            });
            ReceivableList(postData)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = data || [];
                        this.pagination.total = total;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 导出
        handleClickExport() {
            this.loading = true;
            let postData = {
                source_type: this.source_type,
                status: this.tabActiveName,
                page: 1,
                pageSize: this.pagination.total,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    postData[item.field_key] = item.field_value;
                }
            });
            ReceivableListExport(postData)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.xlsxToExcel(data);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        xlsxToExcel(exportData) {
            let tableData = [];
            let fields_list = [];
            const tabActiveName = this.tabActiveName;
            if (this.source_type == "order") {
                // 订单回款
                fields_list = [
                    { field_key: "receivable_no", field_name: "回款编号" },
                    { field_key: "name", p_Field_key: "customer_info", field_name: "客户公司" },
                    { field_key: "payment_company_name", field_name: "回款公司" },
                    { field_key: "order_no", field_name: "订单编号" },
                ];
            } else if (this.source_type == "purchase_refund") {
                // 采购退款
                fields_list = [
                    { field_key: "receivable_no", field_name: "应收编号" },
                    { field_key: "supplier_name", field_name: "供应商名称" },
                    { field_key: "purchase_refund_no", field_name: "采购编号" },
                    { field_key: "approval_id", field_name: "审批编号" },
                ];
            }
            fields_list.push({ field_key: "name", p_Field_key: "uid_info", field_name: "申请人" });
            if (tabActiveName == 1) {
                fields_list.push({
                    field_key: "created_at",
                    field_name: "创建时间",
                });
            } else if (tabActiveName == 2) {
                fields_list = fields_list.concat([
                    { field_key: "confirm_time", p_Field_key: "confirmations", field_name: "确认时间" },
                    { field_key: "payment_method_name", field_name: "收款方式" },
                ]);
            }
            fields_list.push({
                field_key: "receivable_amount",
                field_name: "应收款金额",
            });
            if (tabActiveName == 2) {
                fields_list = fields_list.concat([
                    { field_key: "confirmed_amount", field_name: "已确认金额" },
                    { field_key: "remark", field_name: "备注" },
                ]);
            } else if (tabActiveName == 3) {
                fields_list = fields_list.concat([
                    { field_key: "reject_time", p_Field_key: "rejections", field_name: "驳回时间" },
                    { field_key: "reject_reason", p_Field_key: "rejections", field_name: "驳回原因" },
                ]);
            }

            tableData = exportData.map((row) => {
                const itemdata = {};
                fields_list.forEach((field) => {
                    itemdata[field.field_name] = field.p_Field_key
                        ? row[field.p_Field_key]?.[field.field_key]
                        : row[field.field_key];
                });
                return itemdata;
            });

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(tableData);
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            const fileName = this.nowDate();
            XLSX.writeFile(wb, fileName);
        },
        nowDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            const source_type_name = this.source_type == "order" ? "订单回款应收" : "采购退款应收";
            return `${source_type_name}-${
                this.tabActiveName == 1 ? "待确认" : this.tabActiveName == 2 ? "已确认" : "已驳回"
            }${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
        },
        // 确认
        handleClickReceivedConfirm(row) {
            this.confirmType = "confirm";
            this.receivable_no = row.receivable_no;
            this.paymentConfirmationDialog = true;
        },
        // 批量确认
        handleClickBatchConfirm() {
            if (!this.selectedList.length) return this.$message.error("请选择需要确认的应收单");
            const ids = this.selectedList.map((item) => item.receivable_no);
            this.confirmType = "batch_confirm";
            this.receivable_no = ids;
            this.paymentConfirmationDialog = true;
        },
        // 作废
        handleClickInvalidConfirm(row) {
            this.handleDialogVisible = true;
            this.handleDialogTitle = "作废原因";
            this.handleDialogType = "invalid";
            this.handleDialogIds = [row.receivable_no];
        },
        // 批量驳回
        handleClickBatchReject() {
            if (!this.selectedList.length) return this.$message.error("请选择需要驳回的应收单");
            this.handleDialogVisible = true;
            this.handleDialogTitle = "驳回原因";
            this.handleDialogType = "reject";
            this.handleDialogIds = this.selectedList.map((item) => item.receivable_no);
        },
        // 单个驳回
        handleClickReject(row) {
            this.handleDialogVisible = true;
            this.handleDialogTitle = "驳回原因";
            this.handleDialogType = "reject";
            this.handleDialogIds = [row.receivable_no];
        },
        // 弹框取消
        handleClickCancel() {
            this.handleDialogVisible = false;
            this.handleDialogTitle = "";
            this.handleDialogType = "";
            this.handleRemarks = "";
            this.handleDialogIds = [];
        },
        // 弹框确认
        handleClickConfirm() {
            let error_msg = "请输入" + this.handleDialogTitle;
            if (!this.handleRemarks) return this.$message.error(error_msg);
            if (this.handleDialogType == "invalid") {
                // 作废
                const params = {
                    receivable_no: this.handleDialogIds[0],
                    invalid_reason: this.handleRemarks,
                };
                ReceivableInvalid(params).then((res) => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.selectedList = [];
                                this.handleClickSearch();
                                this.handleClickCancel();
                            },
                        });
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                // 驳回
                const params = {
                    receivable_nos: this.handleDialogIds,
                    reject_reason: this.handleRemarks,
                };
                ReceivableBatchReject(params).then((res) => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.selectedList = [];
                                this.handleClickSearch();
                                this.handleClickCancel();
                            },
                        });
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
        // 查看详情
        handleClickReceivableDetail(row) {
            this.receivable_no = row.receivable_no;
            this.receivableDetailsVisible = true;
        },
        // 查看回款详情
        handleClickPaymentDetail(row) {
            this.receivable_no = row.receivable_no;
            this.repaymentDetailDialogVisible = true;
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_no,
                    name: row.order_no,
                    query_type: "order_no",
                },
            });
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.purchaseId = purchaseId;
            this.purchaseDetailVisible = true;
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id,
            }).then((res) => {});
        },
    },
};
</script>
<style lang="scss" scoped>
.receivable_list_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-tabs {
        ::v-deep {
            .el-tabs__nav {
                margin: 0 16px;
            }
            .el-tabs__header {
                margin: 0;
            }
            .el-tabs__item {
                padding: 0 16px !important;
                height: 48px;
                line-height: 48px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                &.is-active {
                    font-weight: 700;
                    color: rgba(41, 144, 255, 1);
                }
            }
        }
    }
    .content_right_wrap {
        flex: 1;
        padding: 16px;
    }
    .handle_icon_wrap {
        margin-left: 4px;
        i {
            color: rgba(228, 65, 68, 1) !important;
        }
    }
}
.search_container {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;

    .search_top_container {
        display: flex;
        justify-content: space-between;

        span.title {
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-weight: bold;
        }

        .el-button {
            padding: 5px 10px;
        }
    }

    .search_bottom_container {
        padding: 16px 0 0px;
        box-sizing: border-box;

        ul {
            width: 100%;

            li {
                width: 100%;
                display: flex;
                margin-bottom: 12px;

                & > div:nth-child(1) {
                    flex: 1;
                }

                .search_filter_type {
                    margin: 0 8px;
                    width: 86px;
                    max-width: 86px;
                }
                & > div:nth-child(3) {
                    width: 234px !important;
                    flex-shrink: 0;
                    & > div {
                        width: 100% !important;
                    }
                }

                .el-date-editor.el-input {
                    width: 100%;
                    display: block;
                }
                .el-date-editor {
                    width: 100% !important;
                    ::v-deep {
                        .el-range-separator {
                            width: 10%;
                            padding: 0;
                        }
                    }
                }
            }
        }
    }
}

.custom_popover_button {
    padding: 8px 8px;
    margin-left: 0px;
    i {
        font-size: 14px;
    }
    .search_filter_length {
        margin-left: 8px;
        i {
            margin-left: 8px;
            color: rgba(173, 173, 173, 1);
        }
    }
}
.dialog_label_text {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 4px;
}
</style>
<style>
.status_tooltip_item {
    max-width: 420px;
    white-space: normal;
    word-wrap: break-word;
}
.custom-table_row_input {
    input {
        border: 0;
        &:focus {
            border: 1px solid rgba(41, 144, 255, 0.5);
        }
    }
}
</style>
